var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{attrs:{"image":"error","description":"不好意思,服务出现错误了,请退出重试"}})
}
var staticRenderFns = []

export { render, staticRenderFns }